import Splide from "@splidejs/splide";

const onRun = () => {
    const elms = document.getElementsByClassName('splide-static');
    for (let i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
            lazyLoad: true,
            gap: 30
        }).mount();
    }
}

if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}
